define('shoptheme/components/product/compare',[
    "require",
    "jquery",
    "lodash",
    "cartware/components/_base",
    "cartware/components/Dispatcher",
    "json!shoptheme/handles/default.json",
    "gigaset/spinner",
    "text!shoptheme/templates/magnific-popup/default.html",
    "magnific-popup"
], function(
    require,
    $,
    _,
    Component,
    ComponentDispatcher,
    Handles,
    Spinner,
    PopupHtml
) {
    var popupTemplate = null;

    return Component.create({
        overlay:				null,
        attributeSetId:			null,
        itemCount:				0,
        productIds:				null,
        isCheckoutPage:			$('body').hasClass('checkout-onepage-index'),
        isSecure:				('https:' == document.location.protocol),
        config:					{
            controller: 		'catalog/product_compare/',
            getOverlayAction: 	'overlay',
            cookiePrefix:		'compare_list',
            cookieSeparator:	'__'
        },

        $init: function() {
            var self = this;

            self._initData();

            if (this.itemCount > 1) self.showOverlay();

            $(document).on('click', '.compare-trigger', function(e) {
                e.preventDefault();
                var element = $(e.currentTarget),
                    parent = element.closest('.b_product-item__container'),
                    attributeSetId = parent.parent().data('attribute-set-id'),
                    addUrl = element.data('compare-add-url'),
                    removeUrl = element.data('compare-remove-url'),
                    productType = element.data('product-type');

                self.disableOverlay();
                Spinner.add(parent);

                if (element.hasClass('active')) {
                    self._sendRequest(removeUrl);
                    element.removeClass('active');
                } else {
                    if (self._validateProduct(productType)) {
                        if (self.itemCount == 0 || attributeSetId == self.attributeSetId) {
                            element.addClass('active');
                        }
                        self._sendRequest(addUrl);
                    } else {
                        var detailViewUrl = parent.find('.link-add-to-cart').prop('href');
                        self._sendRequest(detailViewUrl, null, null, function(response) {
                            self._showMessage(response, true);
                        });
                    }
                }
            });

            $(document).on('click', '.b_compare-overlay__reset-button', function(e) {
                e.preventDefault();
                var element = $(e.currentTarget),
                    url = element.data('target'),
                    confirmation = element.data('confirmation'),
                    allowClean = confirm(confirmation);

                if (allowClean === true) {
                    Spinner.add();
                    self._sendRequest(url);
                }
            });

            $(document).on('click', '.b_compare-list__remove-button', function(e) {
                e.preventDefault();
                var element = $(e.currentTarget),
                    url = element.prop('href'),
                    colPos = element.data('column');

                Spinner.add(element.parent().parent());

                self._sendRequest(url, {}, function() {
                    $('.b_compare-list__table th:nth-child('+colPos+'), .b_compare-list__table td:nth-child('+colPos+')').fadeOut(300, function() {
                        $(this).remove();
                    });
                });
            });

            $(document).on('click', '.compare-link', function(e) {
                e.preventDefault();

                var element = $(e.currentTarget),
                    parent = element.closest('.b_product-add-to-links'),
                    url = element.prop('href'),
                    productType = element.data('product-type'),
                    notificationInput = $('#watchlist_email');

                if (notificationInput) {
                    notificationInput.removeClass('required-entry');
                    notificationInput.removeClass('validate-email');
                }

                if (self._validateProduct(productType)) {
                    Spinner.add(parent);
                    self._sendRequest(url, null, null, function() {
                        var isInPopup = (element.parents('.popup-body').length > 0);
                        if (isInPopup) {
                            $.magnificPopup.close();
                        }
                    });
                }

                if (notificationInput) {
                    notificationInput.addClass('required-entry');
                    notificationInput.addClass('validate-email');
                }
            });
        },
        _validateProduct: function(type) {
            if (type === 'configurable') {
                if (typeof productAddToCartForm === 'undefined' || !productAddToCartForm.validator.validate()) {
                    return false;
                }
            }

            return true;
        },
        _initData: function() {
            this.itemCount = Mage.Cookies
                .get(this.config.cookiePrefix + this.config.cookieSeparator + 'item_count');
            this.attributeSetId = Mage.Cookies
                .get(this.config.cookiePrefix + this.config.cookieSeparator + 'attribute_set_id');
            this.productIds = Mage.Cookies
                .get(this.config.cookiePrefix + this.config.cookieSeparator + 'product_ids') || [];
            if (typeof this.productIds === 'string') {
                this.productIds = this.productIds.split(',');
            }
            $('.compare-trigger.active','.b_product-item[data-product-id]').removeClass('active');
            _.forEach($('.compare-link'), function(link) {
                link = $(link);
                link.attr('href', link.data('add-url')).text(link.data('add-text'));
            });
            _.forEach(this.productIds, function(productId) {
                $('.compare-trigger', '.b_product-item[data-product-id="'+productId+'"]').addClass('active');
                var removeLink = $('.compare-link[data-product="'+productId+'"]');
                removeLink.attr('href', removeLink.data('remove-url')).text(removeLink.data('remove-text'));
            });

            this.overlay = $('.b_compare-overlay');
            var compareButton = $('.b_compare-overlay__compare-button', this.overlay),
                url = compareButton.prop('href');

            compareButton.prop('href', (this.isSecure === true && url && url.indexOf("http://") == 0)
                ? url.replace("http://", "https://")
                : url);


            compareButton.magnificPopup({
                type: 'ajax',
                alignTop: true,
                overflowY: 'scroll',
                callbacks: {
                    beforeOpen: function() {
                        Spinner.add();
                    },
                    ajaxContentAdded: function() {
                        Spinner.remove();
                        $('[data-toggle="tooltip"]', $('.b_compare-list')).tooltip();
                    }
                }
            });

            $('.b_compare-overlay__info span', this.overlay).text(this.itemCount);
            if (this.itemCount < 2) {
                compareButton.prop('disabled', true);
            } else {
                compareButton.prop('disabled', false);
            }

            this.itemCount > 1 ? this.showOverlay() : this.hideOverlay();
        },
        /**
         * Send ajax request
         *
         * @param url
         * @param data
         * @private
         */
        _sendRequest: function(url, data, callback, onSuccessCallback) {
            var self = this;
            data = data || {};

            // add isAjax param to avoid caching problems
            if (url.indexOf("isAjax=1") === -1 && typeof data === 'string' && data.indexOf("isAjax=1") === -1) {
                url += url.indexOf("?") === -1 ? '?isAjax=1' : '&isAjax=1';
            }

            url = (this.isSecure === true && url.indexOf("http://") == 0)
                ? url.replace("http://", "https://")
                : url;

            $.ajax(url, {
                method: "POST",
                data: data
            }).then(_.bind(function(response) {
                if (typeof callback === 'function') callback(response);
                Spinner.remove();
                if ((response.error || response.success === false) && response.message) {
                    self._showMessage(response.message);
                } else {
                    if (response.item_count == 0) $.magnificPopup.close();
                    if (typeof onSuccessCallback === 'function') onSuccessCallback(response);
                }

                self._initData();

            }, this));
        },
        _renderPopup: function(data) {
            if (null === popupTemplate) {
                popupTemplate = _.template(PopupHtml);
            }

            return popupTemplate(data);
        },
        _showMessage: function(message, configurableOptions) {
            configurableOptions = configurableOptions || false;
            $.magnificPopup.open({
                items: {
                    src: this._renderPopup({ body: message }),
                    type: 'inline'
                },
                callbacks: {
                    open: function() {
                        if (configurableOptions) {
                            var popup = $('.popup-body');
                            new ComponentDispatcher({
                                handles: ["catalog_product_view", "PRODUCT_TYPE_configurable"],
                                apply: Handles
                            });

                            // $(document).trigger("cartware_cart/modal/open", [response]);

                            var addToCartButton = $('button.b_product-detail-add-to-cart__add-to-cart-button', popup),
                                addToCompareLink = $('.compare-link', popup).addClass('btn btn-primary');

                            addToCartButton.replaceWith(addToCompareLink);
                        }
                    }
                }
            });
        },
        showOverlay: function() {
            if (this.isCheckoutPage === false) {
                var overlay = $('.b_compare-overlay');
                overlay.removeClass('slideOut').addClass('slideIn').removeClass('disabled');
            }
        },
        hideOverlay: function() {
            var overlay = $('.b_compare-overlay');
            overlay.removeClass('slideIn').addClass('slideOut');
        },
        disableOverlay: function() {
            $('.b_compare-overlay').addClass('disabled');
        }
    });
});
